import { useEffect, useContext } from 'react'
import usePrevious from 'hooks/usePrevious'
import { INIT_QUERY_PARAMS } from 'config/consts'
import get from 'lodash/get'
import endsWith from 'lodash/endsWith'
import { transformData } from 'components/graphql'
import { SavedPathContext } from '../context/SavedPathContext'

const useRedirect = ({ section, sectionData = {}, recordId, location, location: { pathname }, history, client, selectRecord, getRouteById, sectionPathRedirect = true }) => {
	const { setPath, ...savedPaths } = useContext(SavedPathContext)

	/* if we navigate away from current section, save our location to context */
	const prevValues = usePrevious({ section, pathname })
	useEffect(() => {
		if(sectionPathRedirect && prevValues && prevValues.section !== section && savedPaths[prevValues.section] !== prevValues.pathname) {
			setPath(prevValues.section, prevValues.pathname)
		}
	})

	let redirectPath = ''
	// Checks is redirecting only to /section
	const isPathnameToSection = endsWith(pathname, sectionData.link)
	const shouldRedirect = (!prevValues || prevValues.section !== section) && isPathnameToSection && pathname !== savedPaths[section]
	const redirectToSavedPath = sectionPathRedirect && savedPaths[section]
	const redirectToFirstRecord = !recordId && sectionData.listQuery
	if(shouldRedirect) {
		if(redirectToSavedPath) {
			/* redirect to previously saved location in current subsection */
			redirectPath = savedPaths[section]
		} else if(!recordId && sectionData.listQuery) {
			/* redirect to first available record in cachce */
			try {
				const cachedData = client.readQuery({
					query: sectionData.listQuery,
					variables: sectionData.initialQueryVariables || { filter: {}, params: INIT_QUERY_PARAMS.defaultParams }
				})
				const firstRecord = get(transformData(cachedData, { queryFieldExtract: true }), 'data.items.0', {})
				if(firstRecord.id) {
					redirectPath = getRouteById(firstRecord.id)
				}
			} catch(e) {
				/* nothing to redirect to */
			}
		}
	}
	return redirectPath ? {
		pathname: redirectPath,
		state: {
			isRedirected: true,
			isRedirectToFirstRecord: !redirectToSavedPath && redirectToFirstRecord
		}
	} : null
}

export default useRedirect
